// @ts-check

/** @file Defines the local TaskBoard shell and associations. */

import TaskBoardBase from "../model-bases/task-board.js"
import {PROJECT_REPLICA_DATABASE_IDENTIFIER, projectReplicaModel} from "../database/project-replica-contract.js"
import {PROJECT_REPLICA_SYNC_DECLARATION} from "../database/project-replica-sync.js"

/** Task-to-board placement row in the local application replica. */
const TaskBoardModel = projectReplicaModel(TaskBoardBase)

export default TaskBoardModel

TaskBoardModel.setDatabaseIdentifier(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TaskBoardModel.switchesTenantDatabase(PROJECT_REPLICA_DATABASE_IDENTIFIER)
TaskBoardModel.sync = PROJECT_REPLICA_SYNC_DECLARATION
TaskBoardModel.belongsTo("board")
TaskBoardModel.belongsTo("boardColumn")
TaskBoardModel.belongsTo("task")
